var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default function (_a) {
    var env = _a.env, inputs = _a.inputs, data = _a.data;
    inputs['inputValue'](function (val, relOutpus) {
        var _a;
        var id = (_a = env === null || env === void 0 ? void 0 : env.user) === null || _a === void 0 ? void 0 : _a.id;
        relOutpus['rtn'](data.merge && Object.prototype.toString.call(val) === '[object Object]' ? __assign(__assign({}, val), { userId: id }) : { userId: id });
    });
}
